<template>
	<div style="display: flex;align-content: center;width: 98%;justify-content: space-between;margin: 0;">

		<div style="font-size: 18px;padding-right: 110px;width: 350px;padding-top: 5px;box-sizing: border-box;">
			<img src="../assets/logo.png" style="width:30px;height:30px;border-radius:10px;
			vertical-align: middle;" />
			创优物流管理系统

		</div>

		<div style="display: flex;justify-content: flex-start;align-items: center;">
			<div style="margin-right: 20px;display: flex;justify-content: flex-start;align-items: center;"
				v-if="userInfo.storeType == 2">
				<div style="padding-top: 5px;box-sizing: border-box;">
					<img src="../assets/images/qian.png" alt="" style="width: 30px;height: 30px;">
				</div>
				<span style="margin-left: 10px;">预存款：￥{{userInfo.deposit}} </span>

			</div>
			<span v-if="userInfo.storeType == 2">|</span>
			<div style="margin-right: 20px;display: flex;justify-content: flex-start;align-items: center;margin-left: 5px;
			" v-if="userInfo.storeType == 2">
				<span style="margin-left: 10px;">授信额度：￥{{userInfo.quotaAvailableBalance}}(￥{{userInfo.quota}})</span>
			</div>
			<div>
				<!-- <i class="iconfont icon-xiaoxi" style="color: #7f7f7F;font-size: 20px;"
					@click="drawer1 = true,getnotilylist()"></i>
				<img :src="userInfo.logo" @click="drawer = true"
					style="width:30px;height:30px;border-radius:50px;margin-left:20px;margin-right:10px;vertical-align: middle;" /> -->
				<span style="margin-right: 20px;" >{{username}}</span>
				<!-- @click="drawer = true" -->
				<el-dropdown trigger="click">
					<el-button style=" font-size: 10px;color: black;" type="text" size="medium">
						更多操作
						<el-icon class="el-icon-caret-bottom"></el-icon>
					</el-button>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item @click.native="changeStore">商家资料</el-dropdown-item> -->

						<template>
							<el-dropdown-item @click.native="changePassword">重置密码</el-dropdown-item>
							<el-dropdown-item @click.native="quit">退出登录</el-dropdown-item>
						</template>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<!-- 重置密码 -->
		<el-dialog title="重置密码" :visible.sync="editDialogVisible" width="35%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item label="登录密码:" :label-width="formLabelWidth">
						<el-col :span="18">
							<el-input v-model="form.password" placeholder="请输入登录密码（6-16位字母+数字）" />
						</el-col>
					</el-form-item>
					<el-form-item label="确认登录密码:" :label-width="formLabelWidth">
						<el-col :span="18">
							<el-input v-model="form.surePass" placeholder="请输入确认登录密码" />
						</el-col>
					</el-form-item>

					<el-form-item>
						<el-button :loading="loading" type="primary" @click="resetPass()">提交</el-button>
						<el-button @click="cannelPass">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<el-drawer title="个人信息" :visible.sync="drawer" :direction="direction" :before-close="handleClose" size="20%"
			style="margin-top: 60px;height: 600px;">
			<div id="" style="line-height:50px">
				<img :src="userInfo.logo"
					style="float: left;width:50px;height:50px;border-radius:50px;margin-left:20px" />

				<div style="margin-left: 20px;">
					<span style="padding-left:10px ">{{userInfo.username}}
					</span>
					<!-- <span>{{userInfo.id}}</span> -->
				</div>


			</div>
			<div id="" style="color:black;font-size:14px;padding:10px">

				<span id="" style="margin-left:20px;margin-top:15px;color:black;">

				</span>
			</div>

			<div id="" style="color:black;font-size:14px;padding:10px">
				<span id="">
					名称：
				</span>
				<span id="">
					{{userInfo.storeName}}
				</span>
			</div>

			<div id="" style="color:black;font-size:14px;padding:10px">
				<span id="">
					预存款：
				</span>
				<span id="">
					￥{{userInfo.deposit}}
				</span>
			</div>
			<div id="" style="color:black;font-size:14px;padding:10px">
				<span id="">
					授信额度：
				</span>
				<span id="">
					￥{{userInfo.quotaAvailableBalance}}(￥{{userInfo.quota}})
				</span>
			</div>
			<div id="" style="color:black;font-size:14px;padding:10px">
				<span id="">
					收款账号：
				</span>
				<el-button size="small" type="text" @click="look">
					查看
				</el-button>

			</div>
		</el-drawer>
		<el-dialog :visible.sync="dialoguser" title="收款管理" @close="addDialogClose" :close-on-click-modal="false"
			width='1000px'>
			<div>
				<el-table :data="recharge">
					<el-table-column property="id" label="ID"></el-table-column>
					<el-table-column property="cardType" label="收款类型">
						<template slot-scope="scope">
							<span v-if="scope.row.cardType==1">银行卡</span>
							<span v-if="scope.row.cardType==2">支付宝</span>
							<span v-if="scope.row.cardType==3">微信</span>
						</template>
					</el-table-column>
					<el-table-column property="cardImg" label="收款账号">
						<template slot-scope="scope">
							<el-button v-if="scope.row.cardImg" type="text" size="small" @click="lookzp(scope.row)">查看
							</el-button>
							<el-button v-else type="text" size="small" @click="lookzp(scope.row)">查看</el-button>
						</template>
					</el-table-column>


					<el-table-column label="操作" property="id">
						<template slot-scope="scope">
							<span style="color: skyblue;" @click="setuser(scope.row)">编辑</span>
							<span style="color: red;" @click="storeuserdel(scope.row.id)"> 删除</span>

						</template>　
					</el-table-column>
				</el-table>
				<el-button type="primary" @click="setuser('')">新增收款账号</el-button>
			</div>
			<el-dialog width="60%" :title=usertitle :visible.sync="innerVisible" append-to-body
				:close-on-click-modal="false">
				<el-form v-model="recharge1">
					<el-form-item label="收款类型:" label-width="75px">
						<el-select v-model="recharge1.cardType" class="big" placeholder="请选择">
							<el-option :value='1' label="银行卡">

							</el-option>
							<!-- 		<el-option  value="2" label="支付宝">
								
								</el-option>
								<el-option  value="3" label="微信">
								
								</el-option>
								 -->
						</el-select>
					</el-form-item>
					<el-form-item label="公司名称:" label-width="75px">

						<el-input type="text" style="width: 300px;" v-model="recharge1.cardUserName" auto-complete="off"
							placeholder="请输入公司名称(必填)" />
					</el-form-item>

					<el-form-item label="银行卡号:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="recharge1.cardBankNo" auto-complete="off"
							placeholder="请输入银行卡号" />
					</el-form-item>
					<el-form-item label="收款银行:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="recharge1.cardBank" auto-complete="off"
							placeholder="请输入收款银行" />
					</el-form-item>
					<el-form-item label="银行支行:" label-width="75px">
						<el-input type="text" style="width: 300px; " v-model="recharge1.cardSubbranch"
							auto-complete="off" placeholder="请输入银行支行" />
					</el-form-item>


					<el-button v-if="usertitle=='编辑收款账号'" type="primary" @click="submitClick1()">提交</el-button>
					<el-button v-else type="primary" @click="submitClick()">提交</el-button>
				</el-form>
			</el-dialog>
		</el-dialog>
		<el-dialog :visible.sync="dialogcimg" title="收款账号" style="float:rigin;height: 100%;" :closeOnClickModal="false">
			<el-carousel indicator-position="outside" style="height: 600px;" v-if="cImages!=null">
				<el-carousel-item v-for="(item,index) in cImages" :key="index" style="height: 500px;">
					<img :src="item" style="width: 100%; height: 100%;" />
				</el-carousel-item>
			</el-carousel>
			<div v-else>
				<div style="padding: 10px;font-size: 14px;">
					<span>公司名称：</span>{{cardInfo.cardUserName}}
				</div>
				<div style="padding: 10px;font-size: 14px;">
					<span>银行卡号：</span>{{cardInfo.cardBankNo}}
				</div>
				<div style="padding: 10px;font-size: 14px;">
					<span>收款银行：</span>{{cardInfo.cardBank}}
				</div>
				<div style="padding: 10px;font-size: 14px;">
					<span>银行支行：</span>{{cardInfo.cardSubbranch}}
				</div>
			</div>
			<el-button type="primary" @click="dialogcimg = false">关 闭</el-button>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog style="float:rigin" title="我的信息" :closeOnClickModal="false" :visible.sync="dialogVisible"
			width="80%">
			<div v-if="userInfo.checkStatus==0" style="height: 50px;color: red;padding: 10px;">
				您有待审核记录，请耐心等待！
			</div>
			<div v-if="userInfo.checkStatus==2" style="height: 50px;color: red;padding: 10px;">
				您的商户资料修改信息被驳回，驳回原因如下：{{userInfo.remark}}
			</div>
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">

					<div style="display: flex;align-items: center;justify-content: start;">
						<el-form-item label="名称:" style="width: 40%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.storeName" placeholder="请输入商品名称" />
						</el-form-item>

					</div>
					<div style="display: flex;align-items: center;justify-content: start;">
						<el-form-item label="回调地址:" style="width: 50%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.returnUrl" placeholder="请输入回调地址" />
						</el-form-item>
					</div>
					<div>
						<el-form-item label="appId:" style="width: 20%;">

							<span>{{storeGoodsInfo.appId}}</span>
						</el-form-item>
					</div>
					<div>
						<el-form-item label="加密公钥:" style="width: 80%;">
							<el-span style="color: green;" @click="drawergy=true">查看</el-span>

						</el-form-item>
					</div>
					<div v-if="userInfo.storeType == 2">

						<el-form-item label="预存款:" style="width: 20%;">
							<!-- <el-input type="number" v-model="" placeholder="请输入授信额度">
								</el-input> -->
							<span>{{storeGoodsInfo.quota}}</span>
						</el-form-item>
						<el-form-item label="授信额度:" style="width: 20%;">
							<span>￥{{storeGoodsInfo.quotaAvailableBalance}}(￥{{storeGoodsInfo.quota}})</span>
						</el-form-item>

					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="所属区域:" label-width="75px">
							<el-select clearable filterable v-model="storeGoodsInfo.province" placeholder="请选择省"
								@change="provinceFocus">
								<el-option v-for="item in provinceList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.city" placeholder="请选择市"
								@change="cityFcus">
								<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select clearable filterable v-model="storeGoodsInfo.area" placeholder="请选择区"
								@change="districtFcus">
								<el-option v-for="item in districtList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<el-form-item label="详细地址:" label-width="75px" style="width: 50%;">
						<el-input v-model="storeGoodsInfo.address" placeholder="请输入详细地址">
						</el-input>
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="邮箱:" style="width: 50%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.storeEmail" placeholder="请输入邮箱" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="LOGO:" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit=1
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="证件:" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card"
								:on-preview="handlePictureCardPreview1" :on-remove="handleRemove1"
								:file-list="fileList1" :show-file-list="true" :on-success="onSuccess1">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div style="height: 600px;">
						<div style="text-align: start;margin: 10px;">介绍</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.storeIntro" ref="myQuillEditor" class="editer"
									style="height: 400px;width: 1000px;" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>

				<el-button type="primary" @click="sure">编 辑</el-button>
			</div>
		</el-dialog>
		<el-drawer title="公告" :visible.sync="drawer1" :direction="direction1" :before-close="handleClose1"
			style="width: 1000px;margin-left: 400px;margin-top: 60px;" size="95%">
			<el-collapse accordion style="padding-left: 50px;height: 650px;overflow: hidden;" @change="ggactive">
				<el-collapse-item v-for="(item,index) in notifyList" :name="item.id">
					<template slot="title">
						<span v-if="item.readStatus==0" style="color: red;font-size: 20px;">●</span>
						<span v-else style="color:  #949494;font-size: 20px;">●</span>
						<div v-if="item.readStatus==0" style="float: left;
						width: 1000px;height: 50px;font-size: 14px;font-weight: 700;padding-bottom: 22px;
						color: black;
						">
							<p> {{item.title}}
								<span
									style="padding-left: 550px;font-size: 12px;font-size: 200;color: #7f7f7f;float: right;margin-right: 10px;margin-bottom: 22px;">
									{{item.createDate}}
								</span>
							</p>
						</div>
						<div v-else style="float: left;width: 1000px;height: 50px;font-size: 14px;font-weight: 700;padding-bottom: 22px;
						color: #949494;
						">
							<p> {{item.title}}
								<span
									style="padding-left: 550px;font-size: 12px;font-size: 200;color: #7f7f7f;float: right;margin-right: 10px;margin-bottom: 22px;">
									{{item.createDate}}
								</span>
							</p>
						</div>

					</template>
					<div v-html="item.content.replace(new RegExp('<img', 'gi'),
						`<img style='max-width: 50%; height:auto;display:block'`)"
						style="padding-left: 20px;padding-right: 20px;height: 400px; overflow-y: scroll;"></div>

				</el-collapse-item>
			</el-collapse>
			<el-pagination style="margin: 20px;" background :current-page="userActivityList.pageNum"
				@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
				:total="userActivityList.total" @size-change="handleSizeChange">
			</el-pagination>
		</el-drawer>
		<el-dialog title="公钥" :visible.sync="drawergy">
			<div>
				<span>{{storeGoodsInfo.appPublicKey}}</span>

			</div>
			<el-button type="primary" @click="handleCopy">复制</el-button>
		</el-dialog>
	</div>

</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile();
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		name: "app",
		props: ['heads'],
		data() {
			return {
				drawergy: false,
				drawer1: false,
				direction1: 'ttb',

				userActivityList: [],
				page: {
					pageNum: 1,
					pageSize: 10
				},
				httpUrl: urls,
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				userInfo: {},
				storeGoodsInfo: {},
				cImages: [],
				usertitle: '',
				dialogVisible: false,
				dialogcimg: false,
				recharge1: {},
				cardInfo: {},
				provinceList: {},
				notifyList: [],
				cityList: {},
				districtList: {},
				orderInfo: {},
				fileList: [],
				fileList1: [],
				dialoguser: false,
				innerVisible: false,
				recharge: [],
				drawer: false,
				direction: 'rtl',
				username: "",
				form: {
					password: "",
					surePass: ""
				},
				loading: false,
				mainFormRules: {
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
					surePass: {
						required: true,
						message: "请输入新密码",
						trigger: "blur"
					},
				},
				editDialogVisible: false,
				formLabelWidth: "200px",
			}
		},
		filters: {

		},
		methods: {
			handleCopy() {
				this.copyText(this.storeGoodsInfo.appPublicKey).then(() => {
					this.$message({
						message: '复制成功',
						type: 'success',
						duration: 1500,
					});
				});
			},
			ggactive(val) {
				// console.log(val);
				let data = {
					notifyId: val,
				}
				
				this.$api.addNotifyUserRead(this.$encrypt(data)).then(res => {
					// console.log(res);
					this.getnotilylist()
				})
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getnotilylist()
			},
			handleChange(val) {
				// console.log(val);
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},
			//编辑商家
			sure() {
				// console.log(this.goodsImages);
				this.storeGoodsInfo.storeLogo = this.goodsImages.toString();
				this.storeGoodsInfo.cidImages = this.goodsImages1.toString();
				this.storeGoodsInfo.areaId = this.orderInfo.areaId,
					this.storeGoodsInfo.cityId = this.orderInfo.cityId,
					this.storeGoodsInfo.provinceId = this.orderInfo.provinceId,
					this.storeGoodsInfo.city = this.orderInfo.city,

					this.storeGoodsInfo.province = this.orderInfo.province,
					this.storeGoodsInfo.area = this.orderInfo.area,
					this.storeGoodsInfo.address = this.storeGoodsInfo.address
				this.$api.updateStores(this.$encrypt(this.storeGoodsInfo)).then((res) => {
					// console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;


					} else {
						this.$message.error(res.message);
					}
				})

			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			onSuccess1(response, file, fileList) {
				// console.log(res)
				this.goodsImages1.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages = response.message;
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.goodsImages1.remove(file.response.message);
				}
				this.goodsImages1.remove(file.url);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages = ''
				}
				this.goodsImages = ''
			},
			handlePictureCardPreview1(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			handlePictureCardPreview(file) {

				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			//查询市
			provinceFocus(e) {
				// console.log(e);
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.provinceId = obj.id
				this.orderInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
						// console.log(res.data);
					})
				}
			},
			//查询区
			cityFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.orderInfo.cityId = obj.id
				this.districtList = {}
				if (e) {
					this.$api.findAreas(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},
			districtFcus(e) {
				// console.log(e);
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
				this.orderInfo.areaId = obj.id
			},

			changeStore() {
				this.dialogVisible = true
				this.storeGoodsInfo = {};
				this.orderInfo = {}
				this.goodsImages = '';
				this.fileList = [];
				this.fileList1 = []
				this.getuser()
			},
			storeuserdel(id) {
				this.$api.deletecard(id).then(res => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message.error(res.message);
					}
					this.getuser()
				})
			},
			submitClick1() {
				// console.log(this.recharge1.cardType);

				this.$api.editcard(this.$encrypt(this.recharge1)).then(res => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message.error(res.message);
					}
					this.innerVisible = false;
					this.getuser()
				})
			},
			submitClick() {
				this.$api.addcard(this.$encrypt(this.recharge1)).then(res => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message.error(res.message);
					}
					this.innerVisible = false;
					this.getuser()
				})
			},
			lookpz(item) {

			},
			lookzp(a) {

				if (a.cardImg) {
					this.cImages = a.cardImg.split(',')

				} else {
					this.cImages = null
					this.cardInfo = a
					// console.log(this.cImages);
				}

				this.dialogcimg = true
			},
			setuser(item) {

				this.innerVisible = true
				if (item != '') {
					this.usertitle = '编辑收款账号'
					// this.$api.findStoreLinksById(id).then(res=>{
					this.recharge1 = item


				} else {
					this.usertitle = '新增收款账号'
					this.recharge1 = {}
				}

			},
			addDialogClose() {
				// this.recharge={}
			},
			look() {

				this.dialoguser = true


			},
			handleClose(done) {
				done();

			},
			handleClose1(done) {
				done();

			},
			quit() {
				file: ///C:/Users/86132/Desktop/logo.png
					sessionStorage.removeItem("token");
				sessionStorage.removeItem("isEditSaleprice");
				localStorage.removeItem("vuex");
				this.$router.push("/")
				this.$api.logOut().then(res => {
					if (res.state == 'success') {
						this.$message.success(res.message);
					}

				})
				this.$router.go(0)

			},
			changePassword() {
				this.form = {}
				this.editDialogVisible = true
			},
			//重置密码
			resetPass() {
				if (this.form.password !== this.form.surePass) {
					this.$message.error("两次密码不一致");
					return false;
				}
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
				var re = new RegExp(reg)
				if (!re.test(this.form.password)) {
					this.$message.error("请输入有效的登录密码");
					return false;
				}

				let data = {
					password: this.form.password
				}
				this.$api.sysResetPass(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {
						this.$message.error(res.message);
					}
					this.editDialogVisible = false;
				})
			},
			cannelPass() {
				this.editDialogVisible = false
			},
			getuser() {
				this.$api.getUserInfo().then((res) => {
					// console.log(res);
					res.data = JSON.parse(this.$decrypt(res.data)).data

					if (res.state == 'success') {

						this.userInfo = res.data.user
						if (res.data.user.deposit <= 0 && res.data.user.storeType == 2) {
							this.$message({
								message: '尊敬的商户：您的账户余额已不足，请及时补足余额！',
								type: 'warning'
							});
						}

						this.username = res.data.user.username

						localStorage.setItem('storeType', res.data.user.storeType)
						this.recharge = res.data.card.data
						sessionStorage.setItem('isEditSaleprice', res.data.isEditSaleprice)
						this.storeGoodsInfo = res.data.user
						let imagesArray = res.data.user.cidImages.split(',')
						this.goodsImages = res.data.user.storeLogo
						this.goodsImages1 = res.data.user.cidImages.split(',')

						for (let i = 0; i < imagesArray.length; i++) {
							this.fileList1.push({
								name: imagesArray[i],
								url: imagesArray[i]
							})
						}
						this.fileList.push({
							url: res.data.user.storeLogo
						})
					}
				})
				this.$api.findAreas(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getNotifyList()
			},
			getnotilylist() {
				this.$api.getNotifyList(this.$encrypt({
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize
				})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data

					this.notifyList = res.data.list
					this.userActivityList = res.data
				})
			},

		},

		created() {
			let user = window.sessionStorage.getItem('token');
			if (user) {
				this.getuser()

			}

		}
	}
</script>
<link rel="stylesheet" href="../assets/css/iconfont.css">
<style scoped>
	.sasdfa {
		color: cyan
	}

	.icon-xiaoxi {
		color: #f28f37;
	}

	.fwb img {
		width: 100%;
		height: 100%;
	}
</style>